@keyframes slideDown {
  from {
    height: 0;
  }

  to {
    height: var(--radix-accordion-content-height);
  }
}

@keyframes slideUp {
  from {
    height: var(--radix-accordion-content-height);
  }

  to {
    height: 0;
  }
}

.root {
  --animation-duration: 250ms;
  cursor: pointer;

  & + & {
    border-top: 1px solid var(--gray-400);
  }

  .icon {
    transition: transform 0.25s;
  }

  &[data-state="open"] .icon {
    transform: scaleY(-1);
  }
}

.cut {
  width: 80%;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-top: 1.5rem;
  padding-right: 0.75rem;
  padding-bottom: 1.5rem;
  overflow: hidden;

  [aria-disabled="true"] & {
    opacity: 0.6;
  }
}

.cancelMargins {
  margin-bottom: 0;
}

.preview {
  max-height: 1.3em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  transition: max-height var(--animation-duration);

  .header[data-state="open"] & {
    max-height: 0;
  }
}

.animate {
  overflow: hidden;

  [data-state="open"] > & {
    animation: slideDown var(--animation-duration) ease-out;
  }

  [data-state="closed"] > & {
    animation: slideUp var(--animation-duration) ease-in;
  }
}

.content {
  padding-bottom: 1.5rem;
  overflow: hidden;
}
